<template>
    <BaseDialog
        :showDialog="show"
        maxDialogWidth="1100"
        maxCardHeight="860"
        headline="lang_PUBLISHING_USAGE_BUTTON_EXPORT_COMPLAINTS"
        :close="close"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
<!-- OPTIONS -->
                <v-row>
                    <v-col cols="4">
                        <v-select
                            v-model="mappingAlvId"
                            :items="mappings"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_TEMPLATE')"
                            :placeholder="$t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_TEMPLATE_DEFAULT')"
                            persistent-placeholder
                            clearable
                            :alvqa="alvqa + '-dropdown-template'"
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-select v-model="musicUse" :items="musicUses" :label="$t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_MUSIC_USE')" :alvqa="alvqa + '-dropdown-music-use'" />
                    </v-col>
                    <v-col cols="4">
                        <v-select v-model="soundfileSource" :items="soundfileSources" :label="$t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_SOUNDFILE_SOURCE')" :alvqa="alvqa + '-dropdown-soundfile-source'" />
                    </v-col>
                    <v-col cols="3">
                        <DatePickerFilter context="ComplaintExportDateFrom" :label="$t('lang_GENERAL_CAPTION_DATE_FROM')" :alvqa="alvqa + '-date-from'" />
                    </v-col>
                    <v-col cols="3">
                        <DatePickerFilter context="ComplaintExportDateTo" :label="$t('lang_GENERAL_CAPTION_DATE_TO')" :alvqa="alvqa + '-date-to'" />
                    </v-col>
                    <v-col cols="3">
                        <v-select
                            v-model="stations"
                            :items="stationItems"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_STATIONS')"
                            :placeholder="$t('lang_GENERIC_CAPTION_ALL')"
                            persistent-placeholder
                            multiple
                            clearable
                            :alvqa="alvqa + '-dropdown-stations'"
                        />
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                        <v-checkbox
                            v-model="onlySelected"
                            :disabled="selected.length === 0"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_ONLY_SELECTED', { count: selected.length })"
                            color="generalCheckbox"
                            hide-details
                            :alvqa="alvqa + '-checkbox-only-selected'"
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" class="py-0">
                        <v-checkbox
                            v-model="includeWithoutIdentifier"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_INCLUDE_WITHOUT_IDENTIFIER')"
                            color="generalCheckbox"
                            hide-details
                            class="mt-0"
                            :alvqa="alvqa + '-checkbox-include-without-identifier'"
                        />
                    </v-col>
                </v-row>

<!-- PREVIEW -->
                <v-row v-if="previewError">
                    <v-col><v-alert :type="previewError.code === 'nothing_to_export' ? 'info' : 'error'" dense text class="mb-0" :alvqa="alvqa + '-preview-error'">{{ previewErrorText }}</v-alert></v-col>
                </v-row>
                <template v-if="preview">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-wrap align-center" :alvqa="alvqa + '-counts'">
                            <v-chip small label outlined color="buttonNewEntity" class="mr-2 mb-1"><b class="mr-1">{{ $n(preview.counts.exportable) }}</b><span class="text--primary">{{ $t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_EXPORTABLE') }}</span></v-chip>
                            <v-chip small label outlined color="error" class="mr-2 mb-1"><b class="mr-1">{{ $n(preview.counts.blocked) }}</b><span class="text--primary">{{ $t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_BLOCKED') }}</span></v-chip>
                            <v-chip small label outlined color="warning" class="mr-2 mb-1"><b class="mr-1">{{ $n(preview.counts.pastClaimDeadline) }}</b><span class="text--primary">{{ $t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_LATE') }}</span></v-chip>
                            <v-chip small label outlined color="standardBrownIcon" class="mr-2 mb-1"><b class="mr-1">{{ $n(preview.counts.alreadyExported) }}</b><span class="text--primary">{{ $t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_ALREADY_EXPORTED') }}</span></v-chip>
                            <v-progress-circular v-if="loading" indeterminate size="18" width="2" class="ml-2" color="navigationItemsIconsActive" />
                        </v-col>
                    </v-row>
                    <v-row v-if="tooMany">
                        <v-col class="pt-0">
                            <v-alert color="standardBrownIcon" icon="warning_amber" dense border="left" colored-border class="mb-0" :alvqa="alvqa + '-too-many'">
                                {{ $t('lang_PUBLISHING_USAGE_MESSAGE_WARNING_EXPORT_TOO_MANY', { rows: $n(preview.counts.exportable), max: $n(preview.maxRowsPerFile) }) }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-if="preview.mappingProblem && !mappingAlvId">
                        <v-col class="pt-0">
                            <v-alert color="standardBrownIcon" icon="warning_amber" dense border="left" colored-border class="mb-0" :alvqa="alvqa + '-mapping-problem'">{{ preview.mappingProblem }}</v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pt-0">
                            <v-data-table
                                :headers="previewHeaders"
                                :items="preview.rows"
                                item-key="resultId"
                                dense
                                hide-default-footer
                                :items-per-page="-1"
                                :loading="loading"
                                :no-data-text="$t('lang_ERROR_NOTHING_TO_EXPORT')"
                                class="usage-nested-table"
                                :alvqa="alvqa + '-preview-table'"
                            >
                                <template v-slot:[`item.workIdentifier`]="{ item }">{{ item.workIdentifier || '–' }}</template>
                                <template v-slot:[`item.workTitle`]="{ item }">{{ item.workTitle || '–' }}</template>
                                <template v-slot:[`item.broadcastDate`]="{ item }">{{ date(item.broadcastDate) }} {{ item.broadcastTime }}</template>
                                <template v-slot:[`item.musicSeconds`]="{ item }">{{ item.musicSeconds }} s</template>
                                <template v-slot:[`item.state`]="{ item }">
                                    <BaseTooltip v-if="item.blockers.length">
                                        <template v-slot:content><v-icon small color="error">block</v-icon></template>
                                        <template v-slot:text>{{ item.blockers.map(blockerText).join(' · ') }}</template>
                                    </BaseTooltip>
                                    <BaseTooltip v-if="item.warnings.length">
                                        <template v-slot:content><v-icon small color="warning">schedule</v-icon></template>
                                        <template v-slot:text>{{ item.warnings.map(code => $t('lang_PUBLISHING_USAGE_MESSAGE_WARNING_EXPORT_' + code.toUpperCase())).join(' · ') }}</template>
                                    </BaseTooltip>
                                    <BaseTooltip v-if="item.exportedAt">
                                        <template v-slot:content><v-icon small color="standardBrownIcon">outbox</v-icon></template>
                                        <template v-slot:text>{{ $t('lang_PUBLISHING_USAGE_CAPTION_REVIEW_EXPORTED_AT', { at: item.exportedAt }) }}</template>
                                    </BaseTooltip>
                                </template>
                            </v-data-table>
                            <div v-if="preview.total > preview.rows.length" class="caption subtitleGray--text mt-1">
                                {{ $t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_MORE_ROWS', { shown: $n(preview.rows.length), total: $n(preview.total) }) }}
                            </div>
                        </v-col>
                    </v-row>
                </template>
                <v-row v-if="exportError">
                    <v-col><v-alert type="error" dense text class="mb-0" :alvqa="alvqa + '-export-error'">{{ exportError }}</v-alert></v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-spacer />
            <BaseButton label="lang_GENERAL_BUTTON_CANCEL" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-cancel'" @click="close" />
            <BaseButton
                label="lang_GENERIC_CAPTION_EXPORT"
                icon="file_download"
                :disabled="!canExport"
                :loading="exporting"
                :alvqa="alvqa + '-button-export'"
                @click="exportFile"
            />
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseButton from '@/components/_buttons/BaseButton'
import DatePickerFilter from '@/components/_filters/DatePickerFilter'
import usageApi, { saveDownload } from '@/api/usageApi'
import { usageErrorText } from '@/store/modules/2_publishing/usage'
import { MUSIC_USES, SOUNDFILE_SOURCES } from '../../usageOptions'

const PREVIEW_ROWS = 25

/** The complaint export: which complaints go into the file, GEMA's two choices, and a preview of the rows as the
 *  form will hold them, with the rows the form cannot take and those past GEMA's deadline. */
export default {
    name: 'ComplaintExportDialog',
    components: { BaseDialog, BaseTooltip, BaseButton, DatePickerFilter },
    data() {
        return {
            alvqa: 'publishing-usage-export-dialog',
            mappings: [],
            mappingAlvId: null,
            musicUse: 'Illustrationsmusik',
            soundfileSource: 'GEMA',
            stations: [],
            stationItems: [],
            onlySelected: false,
            includeWithoutIdentifier: false,
            preview: null,
            previewError: null,
            loading: false,
            exporting: false,
            exportError: '',
            timer: null
        }
    },
    computed: {
        show() { return this.$store.getters.getShowComplaintExportDialog },
        scheduleId() { return this.$store.getters.getUsageReviewScheduleId },
        selected() { return this.$store.getters.getSelectedUsageReview },
        dateFrom() { return this.$store.getters.getSelectedComplaintExportDateFrom },
        dateTo() { return this.$store.getters.getSelectedComplaintExportDateTo },
        musicUses() { return MUSIC_USES },
        soundfileSources() { return SOUNDFILE_SOURCES },
        options() {
            return {
                mappingAlvId: this.mappingAlvId,
                musicUse: this.musicUse,
                soundfileSource: this.soundfileSource,
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                stations: this.stations,
                resultIds: this.onlySelected ? this.selected : [],
                includeWithoutIdentifier: this.includeWithoutIdentifier
            }
        },
        tooMany() { return this.preview && this.preview.counts.exportable > this.preview.maxRowsPerFile },
        previewErrorText() { return this.previewError ? usageErrorText(this.previewError) : '' },
        canExport() {
            return this.preview && !this.loading && this.preview.counts.exportable > 0 && !this.tooMany && (this.mappingAlvId || !this.preview.mappingProblem)
        },
        previewHeaders() {
            const h = (text, value, align = 'left') => ({ text: this.$t(text), value, align, sortable: false })
            return [
                h('lang_PUBLISHING_USAGE_CAPTION_WORK_NUMBER', 'workIdentifier'),
                h('lang_PUBLISHING_WORKS_CAPTION_WORK_TITLE', 'workTitle'),
                h('lang_PUBLISHING_USAGE_CAPTION_EXPORT_COL_BROADCAST', 'broadcastDate'),
                h('lang_PUBLISHING_USAGE_CAPTION_STATION', 'broadcaster'),
                h('lang_PUBLISHING_USAGE_CAPTION_PROGRAMME', 'programmeTitle'),
                h('lang_PUBLISHING_SHEETS_DROPDOWN_AVTYPE_EPISODE', 'episodeNumber'),
                h('lang_PUBLISHING_WORKS_CAPTION_DURATION', 'musicSeconds', 'right'),
                h('lang_PUBLISHING_USAGE_CAPTION_EXPORT_COL_DEADLINE', 'claimDeadline'),
                { text: '', value: 'state', sortable: false, width: '80px' }
            ]
        }
    },
    watch: {
        async show(show) {
            if (!show) return
            this.preview = null
            this.previewError = null
            this.exportError = ''
            this.onlySelected = this.selected.length > 0
            this.includeWithoutIdentifier = false
            const response = await usageApi.mappings('export', 'publishing_complaints')
            this.mappings = (response && Array.isArray(response.list) ? response.list : []).map(m => ({ value: m.alvId, text: m.title + ' (' + m.alvId + ')' }))
            this.loadPreview()
        },
        options: {
            deep: true,
            handler() {
                if (!this.show) return
                clearTimeout(this.timer)
                this.timer = setTimeout(this.loadPreview, 300)
            }
        }
    },
    methods: {
        date(value) { return this.$d(new Date(value + 'T00:00:00'), 'alvDateFormat') },
        // A row's blockers are codes of the Usage API; two of them mean what a finding's reason already says
        blockerText(code) {
            const key = {
                no_work_identifier: 'lang_PUBLISHING_USAGE_CAPTION_REASON_WORK_HAS_NO_GEMA_NUMBER',
                station_unknown: 'lang_PUBLISHING_USAGE_CAPTION_REASON_STATION_UNKNOWN',
                station_not_on_form: 'lang_PUBLISHING_USAGE_MESSAGE_ERROR_EXPORT_STATION_NOT_ON_FORM'
            }[code]
            return key ? this.$t(key) : code
        },
        async loadPreview() {
            this.loading = true
            const result = await usageApi.complaintPreview(this.scheduleId, { ...this.options, perPage: PREVIEW_ROWS })
            this.loading = false
            if (!result.ok) {
                this.preview = null
                this.previewError = result.error
                return
            }
            this.previewError = null
            this.preview = result.data
            if (this.stationItems.length === 0 && result.data.byStation) {
                this.stationItems = result.data.byStation.map(s => ({ value: s.stationCode, text: s.stationCode + ' (' + this.$n(s.exportable) + ')' }))
            }
        },
        async exportFile() {
            this.exporting = true
            this.exportError = ''
            const result = await usageApi.exportComplaints(this.scheduleId, this.options)
            this.exporting = false
            if (!result.ok) {
                this.exportError = usageErrorText(result.error)
                return
            }
            saveDownload(result, 'complaints.xlsx')
            const count = Number(result.headers['x-complaints-exported'] || 0)
            this.$store.commit('setSnackbar', { type: 'success', msg: this.$t('lang_PUBLISHING_USAGE_MESSAGE_SUCCESS_EXPORT_DONE', { count: this.$n(count) }) })
            this.close()
            this.$store.dispatch('fetchUsageReview')
            this.$store.dispatch('refreshUsageReviewCounts')
        },
        close() {
            clearTimeout(this.timer)
            this.$store.commit('setShowComplaintExportDialog', false)
            this.$store.commit('setSelectedUsageReviewAction', [])
        }
    }
}
</script>
